<template>
    <div :ref="'container'"
         :class="getCSSClass('media-player-container')">
                <video v-if="mediaType == 'video'" style="max-width: 100%; " :ref="'media'" crossorigin="use-credentials"
                       v-on:click="togglePlay"
                       v-on:timeupdate="updateSlider"
                       v-on:loadeddata="initSlider"
                       v-on:durationchange="enableControls"
                       v-on:ended="resetPlayer"
                       :class="getCSSClass('video-player-object')"
                       preload="metadata"

                >
                    <source :src="mediaUrl" :type="file.mimetype">
                </video>

                <audio v-if="mediaType == 'audio'" style="width: 0px; height: 0px; opacity: 0; visibility: hidden" :ref="'media'" crossorigin="use-credentials"
                       v-on:click="togglePlay"
                       v-on:timeupdate="updateSlider"
                       v-on:loadeddata="initSlider"
                       v-on:durationchange="enableControls"
                       v-on:ended="resetPlayer"
                       preload="metadata"
                       :class="getCSSClass('audio-player-object')"
                >
                    <source :src="mediaUrl" :type="file.mimetype">
                </audio>
                <div :class="getCSSClass('media-player-controls')">
                    <button v-on:click="togglePlay" v-html="playIcon" :class="getCSSClass('media-player-button')"></button>
                    <input type="range" :ref="'slider'" min="0" max="0" style="flex: 1 0 auto"
                           v-on:mousedown="saveStateForSeeking"
                           v-on:mouseup="resumeAfterSeeking"
                           v-on:change="seekMedia"
                    >
                </div>
                <div :class="getCSSClass('media-player-timestamps-container')" >
                    <div :class="getCSSClass('media-player-timestamps')" v-html="timestamps"></div>
                </div>
        </div>
</template>

<script>
export default {
    inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],

    props: {
        url: {type: String},
        file: {type: Object},
    },
    data: function () {
        return {
            mediaStatus: 'paused',
            playIcons: {
                playing: '<i class="fa fa-pause"></i>',
                paused: '<i class="fa fa-play"></i>'
            },
            seekTimer: null,
            fullScreen: false,
            currentTimestamp: '-',
            durationTimestamp: '-',
            mediaUrl: null,
            currentPlayState: 'paused',
        }
    },
    mounted() {
        window.addEventListener('keyup', this.handleKeypress);
        this.mediaUrl = new URL(this.url);
        this.mediaUrl.searchParams.set('mode', 'stream');
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.handleKeypress);
        window.removeEventListener('resize', this.handleWindowResize);
    },
    methods: {
        saveStateForSeeking: function() {
            this.currentPlayState = this.$refs['media'].paused ? 'paused' : 'playing';
            this.$refs['media'].pause();
        },
        resumeAfterSeeking: function() {
            this.$refs['media'].currentTime = this.$refs['slider'].value;
            if (this.currentPlayState == 'playing') {
                this.$refs['media'].play();
            }
        },
        humanTimestamp: function(seconds) {
            let hours = Math.floor(seconds / 3600);
            seconds = seconds - (hours * 3600);
            let minutes = Math.floor(seconds / 60);
            return hours.toString().padStart(2, '0')
                +':'
                +minutes.toString().padStart(2, '0')
                +':'
                +Math.round(seconds - (minutes * 60)).toString().padStart(2, '0');

        },
        close: function() {
            if (this.$refs['media']) {
                this.$refs['media'].pause();
            }
            this.$emit('close');
        },
        handleKeypress: function(event) {
            if (event.key == 'Space') {
                return this.togglePlay();
            }
            if (event.key == 'Escape') {
                return this.close();
            }
        },
        resetPlayer: function(event) {
            this.$refs['media'].pause();
            this.$refs['media'].currentTime = 0;
        },
        pause: function() {
            this.mediaStatus = 'paused'
            return this.$refs['media'].pause();
        },
        play: function() {
            this.mediaStatus = 'playing'
            return this.$refs['media'].play();
        },
        seekMedia: function(event) {
            console.log('seek');
            // if (!this.$refs['media'].paused) {
            //     this.pause();
            //     window.clearTimeout(this.seekTimer);
            //     this.seekTimer = window.setTimeout(() => {
            //         this.play();
            //     }, 500);
            // }
            this.$refs['media'].currentTime = event.target.value;
        },
        changeVolume: function(event) {
            this.$refs['media'].volume = event.target.value / 100;
            //this.$refs['volume'].value = this.$refs['media'].volume * 100;
            // if (window.localStorage) {
            //     window.localStorage.setItem('mediavolume', this.$refs['media'].volume);
            // }
        },
        initSlider: function(event) {
            if (this.$refs['slider']) {
                this.$refs['slider'].setAttribute('max', Math.round(event.target.duration));
                this.durationTimestamp = this.humanTimestamp(event.target.duration);
                this.currentTimestamp = this.humanTimestamp(event.target.currentTime);
            }
        },
        handleWindowResize: function() {
            this.enableControls({target: this.$refs['media']}, 0);
        },
        enableControls: function(event, delay = 1000) {
            window.setTimeout(() => {
                let bcr = event.target.getBoundingClientRect();

                let mediaWidth = event.target.videoWidth * (bcr.height / event.target.videoHeight);
                let offset = (event.target.offsetWidth - mediaWidth) / 2;
                //this.$refs['subcontainer'].style.width = mediaWidth.toString()+'px';
                //this.$refs['controls'].style.visibility = "visible";
                //this.$refs['volume'].value = event.target.volume;
                this.$emit('loadingflag', false);
                if (delay > 0) {
                    this.$refs['media'].volume = 1;
                    //initial loading
                    // if (window.localStorage) {
                    //     this.changeVolume({target: {value: window.localStorage.getItem('mediavolume') * 100}});
                    // }

                }
            }, delay);
            window.addEventListener('resize', this.handleWindowResize);
        },
        updateSlider: function(event) {
            if (this.$refs['slider']) {
                this.$refs['slider'].value = Math.round(event.target.currentTime);
                this.currentTimestamp = this.humanTimestamp(event.target.currentTime);
            }
        },
        togglePlay: function(event) {
            if (this.$refs['media'].paused) {
                return this.play();
            } else {
                return this.pause();
            }
        }
    },
    computed: {
        timestamps: function() {
            return this.currentTimestamp+'&nbsp;/&nbsp;'+this.durationTimestamp;
        },
        mediaType: function() {
            return this.file.mimetype.split('/').shift();
        },
        playIcon: function() {
            return this.playIcons[this.mediaStatus];
        }
    },
    watch: {
    }

}
</script>
<style>
.video-player-player {
    position: relative;
    display: flex;
    max-height: 90vh;
    z-index: 0;
}
.media-player-info {
    transition: opacity 200ms ease-in-out;
    opacity: 0;
    position: absolute;
    top: 0;
    left:0;
    right:0;
    height: 3rem;
    background-color: rgba(0,0,0,.7);
    text-align: center;
    z-index: 10;
    padding-left: .5rem;
    padding-right: .5rem;

}
.video-player-controls {
    transition: opacity 200ms ease-in-out;
    opacity: 0;
    position: absolute;
    bottom: 0;
    left:0;
    right:0;
    height: 4rem;
    background-color: rgba(0,0,0,.7);
    display: flex;
    flex-direction: column;
    z-index: 10;
    padding-left: .5rem;
    padding-right: .5rem;
}
.audio-player-player .video-player-controls,
.video-player-player:hover .video-player-controls,
.video-player-player:hover .media-player-info {
    opacity: 1;
}
.audio-player-controls {
    min-width: 50vw;
    width: 50vw;
    background-color: rgba(0,0,0,.7);
    padding: 1rem;
    border-radius: .5rem;
}
</style>
